module.exports = __webpack_public_path__ + "img/ga.29f203bb.svg";